import { HeadingText } from '@/components/atoms/HeadingText';
import { useFormContext } from '@/components/forms/FormContext';
import { type ReplaceInPersonFormState, StepMap, steps } from '../../constants';
import { isValid } from './state';
import { Step } from '@/components/forms/Step';
import { handleNext } from './routing';
import { useValidateStep } from '@/components/forms/useValidateStep';
import { ReplaceInPersonFormActionMap } from '../../reducer';
import { WizardBoxRadio } from '@/components/WizardBox/WizardBoxRadio';
import { TextAlert } from '@/components/calculators/TextAlert';
import {
	IconInfoBubble,
	IconLightning,
	IconAlarmClock,
	IconSchedule,
} from '@/components/icons';

export interface UrgencyStepProps {
	testId?: string;
}

const UrgencyStep = (props: UrgencyStepProps) => {
	const { testId = 'UrgencyStep' } = props;
	const { state, dispatch } = useFormContext<
		StepMap,
		ReplaceInPersonFormState,
		ReplaceInPersonFormActionMap
	>();
	useValidateStep<
		StepMap,
		ReplaceInPersonFormState,
		ReplaceInPersonFormActionMap
	>(isValid, steps.Urgency);

	function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
		dispatch({ type: 'UPDATE_URGENCY', payload: event.target.value });
	}

	return (
		<div data-testid={testId}>
			<Step<StepMap, ReplaceInPersonFormState, ReplaceInPersonFormActionMap>
				name={steps.Urgency}
				onNext={handleNext}
			>
				<HeadingText
					tag="h1"
					size="h2"
					className="mb-10 mt-10 lg:mb-14 lg:mt-20"
					balanced
				>
					How quickly do you need assistance?
				</HeadingText>

				<div className="mx-auto mb-8 grid max-w-screen-lg grid-cols-1 gap-4 lg:mb-10 lg:grid-cols-3 lg:gap-6">
					<WizardBoxRadio
						label="ASAP"
						description="As soon as possible"
						name="urgencyTimeline"
						id="asap"
						value="ASAP"
						onChange={handleChange}
						icon={
							<IconLightning className="h-auto w-full max-w-8 lg:max-w-10" />
						}
						checked={state.urgency.includes('ASAP')}
					/>
					<WizardBoxRadio
						label="1-2 weeks"
						description="Within the next 14 days"
						name="urgencyTimeline"
						id="1-2-weeks"
						value="1-2 weeks"
						onChange={handleChange}
						icon={
							<IconAlarmClock className="h-auto w-full max-w-8 lg:max-w-10" />
						}
						checked={state.urgency.includes('1-2')}
					/>
					<WizardBoxRadio
						label="2+ weeks"
						description="More than 2 weeks"
						name="urgencyTimeline"
						id="2+-weeks"
						value="2+ weeks"
						onChange={handleChange}
						icon={
							<IconSchedule className="h-auto w-full max-w-8 lg:max-w-10" />
						}
						checked={state.urgency.includes('2+')}
					/>
				</div>
				<TextAlert
					renderIcon={IconInfoBubble}
					title="Why are we asking?"
					text="Your timeline helps us connect you with a trusted local HVAC partner who’ll follow up with you directly."
				/>
			</Step>
		</div>
	);
};

export default UrgencyStep;
